import React, { useEffect, useMemo } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import Form from '../components/Form/Form';
import UiInputText from '../components/Form/UiInputText';
import UiInputSuggest from '../components/Form/UiInputSuggest';
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

/**
 * Aceita dois formatos de entrada:
 * 1. Linha do grid de usinas (ação "Vincular Projeto"), onde `id` é o da usina
 * 2. Payload do próprio vínculo, ao editar pelo grid de vínculos
 */
function montarValoresIniciais(data: any) {
    if (!data) {
        return { usina: null, contrato: null, geracaoEstimada: '', percentualParticipacao: '' };
    }

    if (data.usina) {
        return data;
    }

    return {
        usina: { id: data.id, nome: data.nome },
        contrato: null,
        geracaoEstimada: '',
        percentualParticipacao: '',
    };
}

export default function UsinaContratoForm(props: any) {
    const valoresIniciais = useMemo(() => montarValoresIniciais(props.data), [props.data]);

    const methods = useForm({
        defaultValues: valoresIniciais,
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        reset(valoresIniciais);
    }, [valoresIniciais, reset]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <UiInputSuggest size={12} name="usina" router="usina" idField="id" titleField="nome" label="Usina" />
                        <UiInputSuggest size={12} name="contrato" router="contrato" idField="id" titleField="cli_nome" label="Projeto" />
                        <UiInputText size={6} name="geracaoEstimada" label="Geração Estimada (kWh/mês)" type="number" step="0.01" min="0" />
                        <UiInputText size={6} name="percentualParticipacao" label="Participação (%)" type="number" step="0.01" min="0" max="100" />
                    </div>
                    <p className="text-muted small mb-0">
                        Sem geração estimada, o cálculo de performance usa a geração garantida do projeto.
                    </p>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    );
}
